import { render } from "./WikipediaDetail.vue?vue&type=template&id=4836c314&scoped=true"
import script from "./WikipediaDetail.vue?vue&type=script&lang=js"
export * from "./WikipediaDetail.vue?vue&type=script&lang=js"

import "./WikipediaDetail.vue?vue&type=style&index=0&id=4836c314&scoped=true&lang=scss"
import "./WikipediaDetail.vue?vue&type=style&index=1&id=4836c314&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4836c314"]])

export default __exports__